import { Switch } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { TableCellEntityMode } from 'entities/TableCell';
import { TableSwitchController } from 'stores/common';

import { TableControllerProps } from '../types';

const SwitchController: React.FC<
  TableControllerProps<TableSwitchController>
> = ({ record, className, params }) => {
  const controllerDisabled = params?.mode === TableCellEntityMode.disabled;

  return (
    <Switch
      checked={record.controllerValue}
      onChange={record.setValue}
      className={className}
      disabled={controllerDisabled}
    />
  );
};

export default observer(SwitchController);
